// stores/ScoreStore.js
var createStore = require('fluxible/addons').createStore;
var PersistentStateMixin = require('../mixins/PersistentStateMixin');
var GameStrip = require('../helpers/GameStrip');
var browser = require('../helpers/utils/browser.js');
var gameStripUtils = require('../helpers/utils/gameStripUtils.js');

var ScoreStore = createStore({

    storeName: 'ScoreStore',

    mixins: [PersistentStateMixin],

    initialize: function () {
        this.initDataStore();
        this.status = "EMPTY";
        this.lastUpdate = "";
		this.article = {};
    },

    handlers: {
        'RECEIVE_SCORES':function (scores) {
            try{
                this.initDataStore();
                this.setMatchState(scores);
                this.setPlayerDisplayPosition(scores);
                this.setPlayersList(scores);
                this.setTeams(scores);
                this.setCommentary(scores);
                this.setGameStrip(scores);
                this.setNewsList(scores);
                this.setMatchStats(scores);
                this.setStandings(scores);
                this.setRecentForm(scores);
                this.setHead2Head(scores);
                this.setGameInformation(scores);
                this.setRosters(scores);
                this.setTableLink(scores);
                this.setStatSummary(scores);
                this.setHasStats(scores);
				this.getDataIDs(scores);
                this.setHasArticle(scores);
            }catch(e){
                console.log(e)
            }
            this.status = "UPDATE_COMPLETE";
            this.lastUpdate = new Date();
            this.emitChange();
        },
		'RECEIVED_ARTICLE':function (article) {
			this.getArticleHTML(article);
			this.emitChange();
		},
        'START_UPDATE':function(){
            this.status = "UPDATE_INITIATED";
            this.emitChange();
        }
    },

	getArticleHTML: function(oData){
		if(typeof oData !== 'undefined' &&
           typeof oData.content !== 'undefined' &&
		   oData.content !== null &&
           typeof oData.content.html !== 'undefined'
        ){
			this.article = {};
			this.article.html = oData.content.html;
		}
	},
		
	getDataIDs: function(oData){
		this.data.eventId = 0;
		this.data.leagueId = 0;
		if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined'
		){
			if(typeof oData.header.id !== 'undefined' && oData.header.id !==  null){
				this.data.eventId = oData.header.id;
			}
			if(typeof oData.header.league !== 'undefined' && 
			   oData.header.league !== null &&
			   typeof oData.header.league.midsizeName !== 'undefined' &&
			   oData.header.league.midsizeName !==  null
			){
				this.data.leagueId = oData.header.league.midsizeName;
			}
		}
		   
	},
	
    getArticle: function(){
        return this.article || {};
    },

    setHasArticle: function(oData){
	
        // find if they have a report or a preview
        if(typeof oData !== 'undefined' &&
           typeof oData.article !== 'undefined' &&
		   oData.article !== null &&
           typeof oData.article.type !== 'undefined'
        ){

            if(oData.article.type === "Report" || oData.article.type === "Recap"){
                this.data.hasReport = true;
            }
            if(oData.article.type === "Preview"){
                this.data.hasPreview = true;
            }
			
        }
    },

    hasReport: function(){
        return this.data.hasReport
    },

    hasPreview: function(){
        return this.data.hasPreview;
    },

    setHasStats: function(oData){
        try{
            var bHasStats = false;
            if(typeof oData !== 'undefined' &&
               typeof oData.boxscore !== 'undefined' &&
               typeof oData.boxscore.teams !== 'undefined'
            ){
                var aTeams = oData.boxscore.teams || [];
                var iTeamLen = aTeams.length;
                for (var i = 0; i < iTeamLen; i++) {
                    var oTeam = aTeams[i];
                    if(typeof oTeam.statistics !== 'undefined' &&
                       typeof oTeam.statistics[0] !== 'undefined' &&
                       typeof oTeam.statistics[0].stats !== 'undefined'
                    ){
                        var aStats = oTeam.statistics[0].stats || [];
                        var iStatLen = aStats.length;
                        for (var x = 0; x < iStatLen; x++) {
                            var oStat = aStats[x];
                            if(oStat.type == 'possession' || oStat.type == 'pcpossessionfirst'){ // has to be > 1 as somtimes it arrives a 1% and 99% which is way wrong
                                if((oStat.value*100) > 1){
                                    bHasStats = true;
                                    break;
                                }
                            }
                        }
                        if(bHasStats){
                            break;
                        }
                    }
                }
            }
            this.data.hasStats = bHasStats;
        }catch(e){}
    },

    hasStats: function(){
        return this.data.hasStats;
    },

    setStatSummary: function(oData){
        // takes the home team and the away team and searches the table if available to calculate the positions.
        var aStatsBox = [];
        if(typeof oData !== 'undefined' &&
           typeof oData.standings !== 'undefined' &&
           typeof oData.standings.children !== 'undefined'
        ){
            var aGroups     = oData.standings.children || [];
            var oStandings  = {};
            var iGroupLen   = aGroups.length;
            var hHomeTeam   = this.getHomeTeam();
            var hAwayTeam   = this.getAwayTeam();
            var bFound      = false;
            var aEntries    = [];

            if(iGroupLen > 1){
                // we have more then 1 group we need to find the correct group
                for (var i = 0; i < iGroupLen; i++) {
                    oStandings = aGroups[i];
                    aEntries = (oStandings.standings && oStandings.standings.entries) ? oStandings.standings.entries : [];
                    for (var x = 0; x < aEntries.length; x++) {
                        var hTeam = aEntries[x];
                        if(hTeam.team.id == hHomeTeam.id){
                            bFound = true;
                        }
                        if(bFound){
                            break;
                        }
                    }
                    if(bFound){
                        break;
                    }
                }
            }else{
                // only one group so must be in that group
                oStandings = aGroups[0];
                aEntries = (oStandings.standings && oStandings.standings.entries) ? oStandings.standings.entries : [];
            }

            var iEntryLen   = aEntries.length;
            var hStatsData  = {};

            for (var x = 0; x < iEntryLen; x++) {
                var hTeam = aEntries[x];
                for (var j = 0; j < hTeam.stats.length; j++) {
                    if(typeof hStatsData[hTeam.stats[j].type] === 'undefined'){
                        hStatsData[hTeam.stats[j].type] = [];
                    }
                    var hTmpdata = {
                        value: (hTeam.stats[j].value*1),
                        description: hTeam.stats[j].description,
                        displayValue: hTeam.stats[j].displayValue,
                        team: hTeam.team.id
                    };
                    hStatsData[hTeam.stats[j].type].push(hTmpdata);
                }
            }

            // if neither team has played again don't show the stats.
            if(typeof hStatsData['gamesplayed'] !== 'undefined'){
                if(typeof hStatsData['gamesplayed'][0] !== 'undefined' && hStatsData['gamesplayed'][0].value == 0 && typeof hStatsData['gamesplayed'][1] !== 'undefined' && hStatsData['gamesplayed'][1].value == 0){
                    return;
                }
            }else{
                return; // no played data so i assume never played.
            }

            // priority order of the stats, so if i can't find 1 move on to the next
            var aPriorityStats  = ['pointsfor','pointsagainst','pointsdifference','triesfor','triesagainst','triesdifference','gameswon','gameslost','gamesdrawn','bonuspoints','bonuspointslosing','bonuspointstry','gamesbye','points','gamesplayed'];
            var aReverseStats   = [true,false,true,true,false,true,true,false,true,true,false,true,true,true,true];
            var iPriorityLen = aPriorityStats.length;
            var aStatsToSort = [];
            for (var x = 0; x < iPriorityLen; x++) {
                if(typeof hStatsData[aPriorityStats[x]] !== 'undefined'){
                    aStatsToSort.push(aPriorityStats[x]) ;
                }
                if(aStatsToSort.length >= 4){
                    break;
                }
            }

            // sort each piece of data
            var iStatLen = aStatsToSort.length;
            for (var x = 0; x < iStatLen; x++) {
                var aStats = hStatsData[aStatsToSort[x]];
                var aSorted = aStats.sort(fValueCompare);
                var bReverse = aReverseStats[x] || false;
                if(bReverse){
                    aSorted.reverse();
                }

                // loop the records looking for teams
                var iSortedLen = aSorted.length;
                var hBoxData = {
                    name: aSorted[0].description,
                    home:{
                        abbreviation:'',
                        position:0,
                        value:0,
                        displayValue:0
                    },
                    away:{
                        abbreviation:'',
                        position:0,
                        value:0,
                        displayValue:0
                    }
                };
                var iTeamWatch = 0;
                for (var i = 0; i < iSortedLen; i++) {
                    var oStatData = aSorted[i];
                    if(oStatData.team == hHomeTeam.id){
                        hBoxData.home.color = hHomeTeam.color;
                        hBoxData.home.abbreviation = hHomeTeam.abbreviation;
                        hBoxData.home.position = i+1;
                        hBoxData.home.value = oStatData.value;
                        hBoxData.home.displayValue = oStatData.displayValue;
                        iTeamWatch++;
                    }else if(oStatData.team == hAwayTeam.id){
                        hBoxData.away.color = hAwayTeam.color;
                        hBoxData.away.abbreviation = hAwayTeam.abbreviation;
                        hBoxData.away.position = i+1;
                        hBoxData.away.value = oStatData.value;
                        hBoxData.away.displayValue = oStatData.displayValue;
                        iTeamWatch++;
                    }
                }
                // if we have found at least 1 team allow it to continue.
                if(iTeamWatch == 2){
                    aStatsBox.push(hBoxData);
                }
            }

            function fValueCompare(a,b) {
                if(a.value < b.value){
                    return -1;
                }
                if(a.value > b.value){
                    return 1;
                }
                return 0;
            }
        }
        this.data.teamStatsBox = aStatsBox;
    },

    getStatSummary: function(){
        return this.data.teamStatsBox || [];
    },

    setRosters: function(data){
        this.data.rosters = data.rosters;
    },

    setMatchState: function(oData){
        if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined' &&
           typeof oData.header.competitions !== 'undefined' &&
           typeof oData.header.competitions[0] !== 'undefined' &&
           typeof oData.header.competitions[0].status !== 'undefined' &&
           typeof oData.header.competitions[0].status.type !== 'undefined' &&
           typeof oData.header.competitions[0].status.type.state !== 'undefined'
        ){
            var sState = oData.header.competitions[0].status.type.state;
            if(sState == 'pre'){
                this.data.matchState = 'pre';
            }else if(sState == 'in'){
                this.data.matchState = 'live';
            }else{
                this.data.matchState = 'post';
            }
            //console.log(this.data.matchState);
        }
    },

    getMatchState: function(){
        return this.data.matchState;
    },

    setGameInformation: function(oData){

        var oGameInfo = {
            venueName:'',
            address:'',
            capacity:0,
            attendance:0,
            datetime:'',
            coverage:''
        };

        if(typeof oData !== 'undefined' &&
           typeof oData.gameInfo !== 'undefined' &&
           typeof oData.gameInfo.venue !== 'undefined'
        ){
            var oVenue = oData.gameInfo.venue;
            oGameInfo.venueName     = oVenue && (oVenue.shortName || oVenue.fullName) || '--';
            oGameInfo.address       = oVenue && oVenue.address && oVenue.address.summary || '';
            oGameInfo.capacity      = oVenue && oVenue.capacity || 0;
            oGameInfo.attendance    = oVenue && oVenue.attendance || 0;
            // images are got here as well
        }
        if(typeof oData !== 'undefined' &&
           typeof oData.gameInfo !== 'undefined' &&
           typeof oData.gameInfo.attendance !== 'undefined'
        ){
            oGameInfo.attendance    = oData.gameInfo.attendance || 0;
        }

        if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined' &&
           typeof oData.header.competitions !== 'undefined' &&
           typeof oData.header.competitions[0] !== 'undefined'
        ){
            var oEvent = oData.header.competitions[0];
            oGameInfo.datetime      = oEvent.date || '';
        }

        this.data.gameInformation = oGameInfo;
    },

    getGameInformation: function(){
        return this.data.gameInformation || {};
    },

    setTeams: function(oData){
        var oTeams = {};
        if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined' &&
           typeof oData.header.competitions !== 'undefined' &&
           typeof oData.header.competitions[0] !== 'undefined' &&
           typeof oData.header.competitions[0].competitors !== 'undefined'
        ){
            var aTeams = oData.header.competitions[0].competitors;
            var iTeamLen = aTeams.length;
            for (var i = 0; i < iTeamLen; i++) {
                var oTeam       = aTeams[i];
                var iId         = oTeam.team.id || 0;
                var sHomeAway   = oTeam.homeAway || '';
                var sName       = oTeam.team.name || '--';
                var sAbbr       = oTeam.team.abbreviation || sName;
                var sLogo       = '';
                var sColor      = oTeam.team.color || null;
                if(typeof oTeam.team.logos[0] !== 'undefined' &&
                   typeof oTeam.team.logos[0].href !== 'undefined'
                ){
                    sLogo       = oTeam.team.logos[0].href;
                }else{
                    sLogo       = 'http://a.espncdn.com/combiner/i?img=/i/teamlogos/soccer/500/default-team-logo-500.png?w=100&h=100&transparent=true';
                }

                if(sColor === null){
                    if(sHomeAway == 'home'){
                        sColor = '#ffc300';
                    }else{
                        sColor = '#d31346';
                    }
                }else{
                    if (sColor.substring(0, 1) != "#") {
                        sColor = '#'+sColor;
                    }
                }

                oTeams[sHomeAway] = {
                    name:sName,
                    abbreviation:sAbbr,
                    logo:sLogo,
                    id:iId,
                    color:sColor
                };

            }
        }
        this.data.teams = oTeams;
    },

    getHomeTeam: function(){
        return this.data.teams.home || {};
    },

    getAwayTeam: function(){
        return this.data.teams.away || {};
    },

    setHead2Head: function(data){
        this.data.head2head = data.headToHeadGames;
    },

    setRecentForm: function(oData){
        if(typeof oData !== 'undefined' &&
           typeof oData.lastFiveGames !== 'undefined'
        ){
            this.data.form = oData.lastFiveGames;
        }
    },

    setNewsList: function(oData){
        if(typeof oData !== 'undefined' &&
           typeof oData.news !== 'undefined'
        ){
            this.data.newsList = oData.news;
        }
    },

    setStandings: function(oData){
        if(typeof oData !== 'undefined' &&
           typeof oData.standings !== 'undefined'
        ){
            this.data.standings = oData.standings;
        }
    },

    setGameStrip: function(data){
        try{
            this.data.gameStrip = new GameStrip({
                sport : 'rugby',
                event :  data.header
            });
        }catch(e){}
    },

    setMatchStats: function(data){
        try{
            var strip = this.getGameStripDetails();
            var homeData;
            var awayData;
            // Added team id check to set home/away stats
            if(data.boxscore.teams[0].team.id === strip.teams.home.id){
                homeData = data.boxscore.teams[0].statistics[0].stats;
                awayData = data.boxscore.teams[1].statistics[0].stats;
            }else{
                homeData = data.boxscore.teams[1].statistics[0].stats;
                awayData = data.boxscore.teams[0].statistics[0].stats;
            }
            this.data.matchStats = {
                home : homeData,
                away : awayData
            };
        }catch (e){
            this.data.matchStats = {
                home : {},
                away : {}
            };
        }
    },

    setTableLink:function(oData){

        this.data.tableLink = '';

        if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined' &&
           typeof oData.header.league !== 'undefined' &&
           typeof oData.header.league.midsizeName !== 'undefined'
        ){
            this.data.tableLink = '/rugby/table/_/league/'+oData.header.league.midsizeName;
        }else{
            // during data migration this is a fallback until above is populated.
            if(typeof oData !== 'undefined' &&
                typeof oData.header !== 'undefined' &&
                typeof oData.header.league !== 'undefined' &&
                typeof oData.header.league.id !== 'undefined'
            ){
                this.data.tableLink = '/rugby/table/_/league/'+oData.header.league.id;
            }
        }
    },

    getTableLink:function(oData){
        return this.data.tableLink || '';
    },

    setCommentary:function(oData){
        // Look for the data
        var aCommentary = [];
        if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined' &&
           typeof oData.header.competitions !== 'undefined' &&
           typeof oData.header.competitions[0] !== 'undefined' &&
           typeof oData.header.competitions[0].details !== 'undefined'
        ){
            var aEvents = oData.header.competitions[0].details;
            var iEventLen = aEvents !== null ? aEvents.length : 0;
            var iPrevType = 0;
            for (var i = 0; i < iEventLen; i++) {
                var oEvent      = aEvents[i];
                var sTime       = '';
                if(typeof oEvent.clock !== 'undefined'){
                    sTime       = oEvent.clock.displayValue || '';
                }else if(typeof oEvent.time !== 'undefined'){
                    sTime       = oEvent.time.displayValue || '';
                }
                var sText       = oEvent.type.text || oEvent.text || '';
                var sType       = (oEvent.type.id*1) || 0;
                var iHomeScore  = (oEvent.homeScore*1) || 0;
                var iAwayScore  = (oEvent.awayScore*1) || 0;
                var iId         = oEvent.sequenceNumber || 0;
                var sTeamName   = '';

                if(typeof oEvent.team !== 'undefined' &&
                   typeof oEvent.team.displayName !== 'undefined'
                ){
                    var sTeamName   = oEvent.team.displayName;
                }

                if(typeof oEvent.participants !== 'undefined' &&
                   typeof oEvent.participants[0] !== 'undefined' &&
                   typeof oEvent.participants[0].athlete !== 'undefined'
                ){
                    var oAthlete    = oEvent.participants[0].athlete;
                    var sName       = oAthlete.displayName;

                    if(sType == 8){
                        sText = sName + ' is brought on';
                    }else if(sType == 7){
                        sText = sName + ' is taken off';
                    }else if(sType == 1){
                        sText = 'TRY! '+sName + ' scores for '+sTeamName;
                    }else if(sType == 2){
                        sText = sName + ' makes the conversion';
                    }else if(sType == 3){
                        sText = 'Penalty to '+sTeamName+'! '+sName + ' scores';
                    }else if(sType == 4){
                        sText = 'Drop Goal! '+sName + ' scores for '+sTeamName;
                    }else if(sType == 5){
                        sText = sName + ' receives a yellow card';
                    }else if(sType == 6){
                        sText = sName + ' is sent off';
                    }
                }

                if(sType == 14){
                    sText = 'PENALTY! Try awarded to '+sTeamName;
                }

                /* Knockout the doubles */
                if((sType == 9 && iPrevType ==9) || (sType == 10 && iPrevType == 10) || (sType == 11 && iPrevType == 11) || (sType == 12 && iPrevType == 12) || (sType == 13)){
                    continue;
                }

                // Capitalize words for events that indicate start/end of halves
                if(sType == 12 || sType == 11 || sType == 10 || sType == 9){
                    sText = sText.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
                }

                var oTmpEvent = {
                    id:iId,
                    type:sType,
                    text:sText,
                    time:sTime,
                    homeScore:iHomeScore,
                    awayScore:iAwayScore
                }

                aCommentary.push(oTmpEvent);
                iPrevType = sType;
            }
            if(this.getMatchState !== 'live'){
                aCommentary = aCommentary.reverse();
            }

        }

        if(aCommentary.length >= 1){
            this.data.hasCommentary = true;
        }

        this.data.commentary = aCommentary;
    },

    getCommentary:function(){
        return this.data.commentary || [];
    },

    hasCommentary:function(){
        return this.data.hasCommentary || false;
    },

    setPlayerDisplayPosition:function(oData){

        var rSortedPlayers  = {};
        var rHomeAwayMap    = {};
        var oSub            = {
            home:{},
            away:{}
        };

        //loop players and add to default order
        if(typeof oData !== 'undefined' &&
           typeof oData.rosters !== 'undefined'
        ){
            var iTeamLen = oData.rosters.length;
            for (var x = 0; x < iTeamLen; x++) {
                if(typeof oData.rosters[x].roster === 'undefined'){
                    continue;
                }
                var aPlayers    = oData.rosters[x].roster || [];
                var sHomeAway   = oData.rosters[x].homeAway || '';
                rSortedPlayers[sHomeAway] = {};
                rSortedPlayers[sHomeAway].playerList = [];
                rSortedPlayers[sHomeAway].playerMap = {};
                var iPlayerLen  = aPlayers.length;
                for (var i = 0; i < iPlayerLen; i++) {
                    var oPlayer = aPlayers[i];
                    rSortedPlayers[sHomeAway].playerList.push(oPlayer.athlete.id);
                    rSortedPlayers[sHomeAway].playerMap[oPlayer.athlete.id] = (rSortedPlayers[sHomeAway].playerList.length-1);
                    rHomeAwayMap[oPlayer.athlete.id] = sHomeAway;
                }
            }
        }

        // loop details to find when a player goes on and off and map to a single event.
        if(typeof oData !== 'undefined' &&
           typeof oData.header !== 'undefined' &&
           typeof oData.header.competitions !== 'undefined' &&
           typeof oData.header.competitions[0] !== 'undefined' &&
           typeof oData.header.competitions[0].details !== 'undefined'
        ){
            var aEvents = oData.header.competitions[0].details;
            var iEventLen = aEvents !== null ? aEvents.length : 0;
            for (var i = 0; i < iEventLen; i++) {
                var oEvent  = aEvents[i];
                var sType   = oEvent.type.id || 0;
                if(sType == 7 || sType == 8){
                    // get the player id
                    if(typeof oEvent.participants !== 'undefined' &&
                       typeof oEvent.participants[0] !== 'undefined' &&
                       typeof oEvent.participants[0].athlete !== 'undefined'
                    ){
                        var oAthlete    = oEvent.participants[0].athlete;
                        var sTeam       = rHomeAwayMap[oAthlete.id] || '';
                        var sTime       = oEvent.clock.value || '';

                        if(sTeam !== ''){ //if for some reason the player is not in the roster.
                            if(typeof oSub[sTeam] === 'undefined'){
                                oSub[sTeam] = {};
                            }

                            if(typeof oSub[sTeam][sTime] === 'undefined'){
                                oSub[sTeam][sTime] = {
                                    in:null,
                                    out:null
                                };
                            }

                            if(sType == 7){
                                oSub[sTeam][sTime].displayTime = oEvent.clock.displayValue;
                                oSub[sTeam][sTime].out = oAthlete.id;
                                oSub[sTeam][sTime].outName = oAthlete.displayName;
                            }else{
                                oSub[sTeam][sTime].displayTime = oEvent.clock.displayValue;
                                oSub[sTeam][sTime].in = oAthlete.id;
                                oSub[sTeam][sTime].inName = oAthlete.displayName;
                            }
                        }
                    }
                }
            }
        }

        // now we know who subbed who we need to map these changes into positions.
        for (var sKey in oSub) {
            if (oSub.hasOwnProperty(sKey)) {

                var aKeys = Object.keys(oSub[sKey]),
                iLen = aKeys.length;
                aKeys.sort();

                for (var i = 0; i < iLen; i++){
                    var oSubstitute = oSub[sKey][aKeys[i]];

                    if(oSubstitute.in !== null && oSubstitute.out !== null){
                        var iCurrPosIn = rSortedPlayers[sKey].playerMap[oSubstitute.in];
                        var iCurrPosOut = rSortedPlayers[sKey].playerMap[oSubstitute.out];

                        // move the player
                        rSortedPlayers[sKey].playerList[iCurrPosIn]     = oSubstitute.out;
                        rSortedPlayers[sKey].playerList[iCurrPosOut]    = oSubstitute.in;
                        rSortedPlayers[sKey].playerMap[oSubstitute.out] = iCurrPosIn;
                        rSortedPlayers[sKey].playerMap[oSubstitute.in]  = iCurrPosOut;
                    }
                }
            }
        }

        this.data.playersList = rSortedPlayers;
        this.data.substituteEvents = oSub;

    },

    setPlayersList:function(oData){
        var hSortedPlayers = {};
        var oSubs = this.data.substituteEvents;

        if(typeof oData !== 'undefined' &&
           typeof oData.rosters !== 'undefined'
        ){
            // itterate all events to see who was subbed on
            var rSubbed = {};
            var rAthleteEvents = {};
            if(typeof oData.header !== 'undefined' &&
               typeof oData.header.competitions !== 'undefined' &&
               typeof oData.header.competitions[0] !== 'undefined' &&
               typeof oData.header.competitions[0].details !== 'undefined'
            ){
                var aEvents = oData.header.competitions[0].details;
                var iEventLen = aEvents !== null ? aEvents.length : 0;
                for (var i = 0; i < iEventLen; i++) {
                    var oEvent  = aEvents[i];
                    var sType   = oEvent.type.id || 0;

                    var iAthleteId = 0;
                    if(typeof oEvent.participants !== 'undefined' &&
                       typeof oEvent.participants[0] !== 'undefined' &&
                       typeof oEvent.participants[0].athlete !== 'undefined'
                    ){
                        var oAthlete    = oEvent.participants[0].athlete;
                        iAthleteId = oAthlete.id;
                    }

                    if(iAthleteId){
                        if(typeof rAthleteEvents[iAthleteId] === 'undefined'){
                            rAthleteEvents[iAthleteId] = {};
                        }
                        if(sType == 8){
                            // get the player id
                            if(typeof oEvent.participants !== 'undefined' &&
                               typeof oEvent.participants[0] !== 'undefined' &&
                               typeof oEvent.participants[0].athlete !== 'undefined'
                            ){
                                var oAthlete    = oEvent.participants[0].athlete;
                                var rSubbData   = {};
                                if(typeof oSubs.home[oEvent.clock.value] !== 'undefined' && oSubs.home[oEvent.clock.value].in == iAthleteId){
                                    rSubbData = oSubs.home[oEvent.clock.value];
                                }else if(typeof oSubs.away[oEvent.clock.value] !== 'undefined' && oSubs.away[oEvent.clock.value].in == iAthleteId){
                                    rSubbData = oSubs.away[oEvent.clock.value];
                                }
                                rSubbed[iAthleteId] = '('+rSubbData.displayTime+') '+rSubbData.outName;
                            }
                        }else{
                            // build an array of every type and time.
                            if(typeof rAthleteEvents[iAthleteId][sType] === 'undefined'){
                                rAthleteEvents[iAthleteId][sType] = [];
                            }
                            rAthleteEvents[iAthleteId][sType].push(oEvent.clock.displayValue);
                        }
                    }
                }
            }

            //console.log(rAthleteEvents);

            var iTeamLen = oData.rosters.length;
            for (var x = 0; x < iTeamLen; x++) {

                if(typeof oData.rosters[x].roster === 'undefined'){
                    continue;
                }

                var aPlayers    = oData.rosters[x].roster || [];
                var sHomeAway   = oData.rosters[x].homeAway || '';
                var iPlayerLen  = aPlayers.length;
                for (var i = 0; i < iPlayerLen; i++) {

                    var oPlayer = aPlayers[i];
                    var bActive = (oPlayer.active === true) ? true : false;
                    var bCaptain= (oPlayer.captain === true) ? true : false;
                    var iId     = oPlayer.athlete.id || 0;
                    var sName   = oPlayer.athlete.displayName || '-';
                    var iNumber = oPlayer.jersey || '-';
                    var sPosition = oPlayer.position.abbreviation || '';
                    var aStats  = oPlayer.stats || [];
                    var iTries  = 0;
                    var iRuns   = 0;
                    var iMetres = 0;
                    var iTackles= 0;
                    var iMissed = 0;
                    var iYellow = 0;
                    var iRed    = 0;
                    var iConverted = 0;
                    var iPenalties = 0;

                    var hToolTips = {};
                    if(typeof rAthleteEvents[iId] !== 'undefined'){
                        if(typeof rAthleteEvents[iId]['1'] !== 'undefined'){
                            iTries = rAthleteEvents[iId]['1'].length || 0;
                        }
                        if(typeof rAthleteEvents[iId]['2'] !== 'undefined'){
                            iConverted = rAthleteEvents[iId]['2'].length || 0;
                        }
                        if(typeof rAthleteEvents[iId]['3'] !== 'undefined'){
                            iPenalties = rAthleteEvents[iId]['3'].length || 0;
                        }
                        if(typeof rAthleteEvents[iId]['5'] !== 'undefined'){
                            iYellow = rAthleteEvents[iId]['5'].length || 0;
                        }
                        if(typeof rAthleteEvents[iId]['6'] !== 'undefined'){
                            iRed = rAthleteEvents[iId]['6'].length || 0;
                        }
                    }

                    var iStatLen = aStats.length;
                    var iStatWatch = 0;
                    for (var v = 0; v < iStatLen; v++) {
                        var oStat = aStats[v];
                        if(oStat.type == 'tries'){
                            iTries = iTries || oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'runs'){
                            iRuns = oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'metres'){
                            iMetres = oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'tackles'){
                            iTackles = oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'missedtackles'){
                            iMissed = oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'yellowcards'){
                            iYellow = iYellow || oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'redcards'){
                            iRed = iRed || oStat.displayValue || '0';
                            iStatWatch++;
                        }else if(oStat.type == 'conversiongoals'){
                            iConverted =  iConverted || oStat.displayValue || '0';
                            iStatWatch++;
                        }

                        if(iStatWatch >= 8){
                            break;
                        }
                    }

                    var bSubbed = false;
                    var sSubTooltip = '';
                    if(typeof rSubbed[iId] !== 'undefined'){
                        //console.log(rSubbed[iId]);
                        sSubTooltip = rSubbed[iId];
                        bSubbed = true;
                    }

                    var oTmpPlayer = {
                        id:iId,
                        number:iNumber,
                        name:sName,
                        captain:bCaptain,
                        onPitch:bActive,
                        tries:iTries,
                        runs:iRuns,
                        runMetres:iMetres,
                        tackles:iTackles,
                        yellowCards:iYellow,
                        redCards:iRed,
                        conversionGoals:iConverted,
                        missedTackles:iMissed,
                        homeAway:sHomeAway,
                        position:sPosition,
                        subbed:bSubbed,
                        penalties:iPenalties,
                        events:rAthleteEvents[iId],
                        subTip:sSubTooltip
                    }

                    hSortedPlayers[iId] = oTmpPlayer;
                }
            }
        }
        this.data.playersData = hSortedPlayers;
    },

    getPlayersList:function(sTeam){

        if (sTeam !== 'home' && sTeam !== 'away'){
            sTeam = 'home';
        }

        var hTeamInfo = this.data.playersList[sTeam] || {};
        var aPlayersList = [];
        if(typeof hTeamInfo.playerList !== 'undefined'){
            var iPlayerLen  = hTeamInfo.playerList.length;
            for (var i = 0; i < iPlayerLen; i++) {
                aPlayersList.push(this.data.playersData[hTeamInfo.playerList[i]]);
            }
        }
        return aPlayersList;
    },

    getTeamGroup: function(childStandings){
        var self = this;
        var homeId = self.data.gameStrip.teams.home.id;
        var awayId = self.data.gameStrip.teams.away.id;
        var _r = {};

        childStandings.map(function(standing, i){
            standing.standings.entries.map(function(entry){

                // console.log(entry.team.id , homeId,  awayId);
                // console.log(entry.team.id === homeId || entry.team.id === awayId);
                if(entry.team.id === homeId || entry.team.id === awayId){
                    // return entry;
                    // console.log(standing,1377);
                    _r = standing;
                }
            });
        });
        // console.log(entries);
        return _r;
    },

    getLeagueTable:function(){
        var leagueTable = [];
        try {
            var childStandings = this.data && this.data.standings && this.data.standings.children;
            var standings = childStandings.length === 1 ? childStandings[0] : this.getTeamGroup(childStandings);
            var entries = standings.standings.entries;

            for (var i = 0; i < entries.length; i++) {
                var standing = entries[i];
                var tableData = {
                    name : standing.team.displayName,
                    href : standing.team.links && standing.team.links[0].href || '#'
                };
                for (var j = 0; j < standing.stats.length; j++) {
                    if(standing.stats[j].name === 'rank'){
                        tableData.position = standing.stats[j].displayValue;
                    }
                    if(standing.stats[j].name === 'gamesPlayed'){
                        tableData.played = standing.stats[j].displayValue;
                    }
                    if(standing.stats[j].name === 'pointsDifference'){
                        tableData.pointsDifference = standing.stats[j].displayValue;
                    }
                    if(standing.stats[j].name === 'points'){
                        tableData.points = standing.stats[j].displayValue;
                    }
                }
                leagueTable.push(tableData);
            }
        } catch (e) {}
        return leagueTable;
    },

    setLeagueName: function(oData){
        var sLeagueName = '';
        if(typeof oData !== 'undefined' &&
           typeof oData.standings !== 'undefined' &&
           typeof oData.standings.name !== 'undefined'
        ){
            sLeagueName = oData.standings.name;
        }
        this.data.leagueName = sLeagueName;
    },

    getLeagueName: function () {
        return this.data.leagueName || '';
    },

    initDataStore:function(){

        /* remember to initilise so it will work later */
        this.data = {};
        this.data.commentary        = [];
        this.data.hasCommentary     = false;
        this.data.hasStats          = false;
        this.data.playersData       = {};
        this.data.playersList       = {};
        this.data.teams             = {};
        this.data.gameInformation   = {};
        this.data.newsList          = {};
        this.data.matchState        = 'pre';
        this.data.tableLink         = '';
        this.data.leagueName        = '';
        this.data.teamStatsBox      = [];
        this.data.substituteEvents  = {};
        this.data.standings         = {};

        this.data.homeTeam        = [];
        this.data.awayTeam        = [];
        this.data.homeTeamAbbr    = "";
        this.data.awayTeamAbbr    = "";
        this.data.homeTeamName    = "-";
        this.data.awayTeamName    = "-";
        this.data.homeTeamScore   = "-";
        this.data.awayTeamScore   = "-";
        this.data.homeTeamId      = 0;
        this.data.awayTeamId      = 0;
        this.data.homeTeamStats   = {};
        this.data.awayTeamStats   = {};
        this.data.events          = [];

        // Set up the venues
        this.data.venue = {};
        this.data.venue.name      = "";
        this.data.venue.capacity  = "";
        this.data.venue.address   = "";

        // Set up the home team
        this.data.homeTeam          = {};
        this.data.homeTeam.name     = "";
        this.data.homeTeam.abbr     = "";
        this.data.homeTeam.score    = "";
        this.data.homeTeam.id       = "";
        this.data.homeTeam.stats    = {};
        this.data.homeTeam.roster   = [];

        // Set up reports+previews
        this.data.hasReport         = false;
        this.data.hasPreview        = false;        

    },
    getStatus: function () {
        return this.status;
    },
    getLastUpdate: function () {
        return this.lastUpdate;
    },
    getHomeSquad: function(){
        return this.data.homeTeam.roster;
    },
    getAwaySquad: function(){
        return this.data.awayTeam;
    },
    getHomeScore: function(){
        return this.data.homeTeam.score;
    },
    getAwayScore: function(){
        return this.data.awayTeamScore;
    },
    getHomeAbbr: function(){
        return this.data.homeTeam.abbr;
    },
    getAwayAbbr: function(){
        return this.data.awayTeamAbbr;
    },
    getHomeName: function(){
        return this.data.homeTeam.name;
    },
    getAwayName: function(){
        return this.data.awayTeamName;
    },
    getHomeStats: function(){
        return this.data.homeTeam.stats;
    },
    getAwayStats: function(){
        return this.data.awayTeamStats;
    },
    getAwayId: function(){
        return this.data.awayTeamId;
    },
    getHomeId: function(){
        return this.data.homeTeamId;
    },
    getAthletes: function(){
        return this.data.athletes;
    },
    getAthlete: function(iAthleteId){
        return this.data.athletes[iAthleteId];
    },
    getMatchEvents: function(){
        return this.data.events;
    },
    getGameStripDetails: function(){
        return this.data.gameStrip;
    },
    getNewsList: function(){
        return this.data.newsList;
    },

    getMatchStats: function(map){
        var _filterMap = {
            rugby : {
                runs : {
                    order : 1,
                    name : 'Runs'
                },
                metres : {
                    order : 2,
                    name : 'Metres Run'
                },
                cleanBreaks : {
                    order : 3,
                    name : 'Line Breaks'
                },
                tackles : {
                    order : 4,
                    name : 'Tackles'
                },
                missedTackles : {
                    order : 5,
                    name : 'Missed Tackles'
                },
                turnoverKnockOn : {
                    order : 6,
                    name : 'Knock Ons'
                }
            }
        };
        var matchStats = [];
        var homeStats = this.data.matchStats.home;
        var awayStats = this.data.matchStats.away;

        _filterMap = map || _filterMap.rugby;

        processStats(homeStats, 'home');
        processStats(awayStats, 'away');

        function processStats(stats, team){
            for (var i = 0, len = stats && stats.length; i < len; i++) {
                var stat = stats[i];
                var matchStat = {};
                var order = _filterMap[stat.name] && _filterMap[stat.name].order;

                if(order){
                    matchStats[order] = matchStats[order] || {};
                    matchStats[order][team] = stat.displayValue;
                    matchStats[order].displayName = _filterMap[stat.name].name || stat.displayName;
                    matchStats[order].abbreviation = stat.abbreviation;
                }
            }
        }

        return matchStats;
    },

    getStatPercent: function(statName){
        var homeStats = this.data.matchStats.home;
        var statPercent = [];

        for (var i = 0, len = homeStats && homeStats.length; i < len; i++) {
            var stat = homeStats[i];
            if(stat.name === statName){
                var displayNumber = Number(stat.displayValue);
                var isDecimal = (displayNumber % 1 !== 0);
                var homeStat = Math.round(displayNumber * (isDecimal ? 100 : 1));
                statPercent.push(homeStat);
                statPercent.push(homeStat === 0 ? 0 : 100-homeStat);
            }
        }
        return statPercent;
    },

    getStat: function(statName){
        var homeStats = this.data.matchStats.home;
        var awayStats = this.data.matchStats.away;
        var foundStat = [];

        function process(stats){
            for (var i = 0, len = stats && stats.length; i < len; i++) {
                var stat = stats[i];
                if(stat.name === statName){
                    var displayNumber = Number(stat.displayValue);
                    foundStat.push(displayNumber);
                }
            }
        }
        process(homeStats);
        process(awayStats);
        return foundStat;
    },

    getHead2Head: function(){
        var head2head = [];
        try{
            var self = this;
            var head2headEvents = this.data.head2head[0].events;
            var team = this.data.head2head[0].team;
            var home = {
                id : this.data.gameStrip.teams.home.id,
                name : this.data.gameStrip.teams.home.name,
                abbreviation : this.data.gameStrip.teams.home.abbreviation,
                logo : this.data.gameStrip.teams.home.logo,
                url : this.data.gameStrip.teams.home.url
            };
            var away  = {
                id : this.data.gameStrip.teams.away.id,
                name : this.data.gameStrip.teams.away.name,
                abbreviation : this.data.gameStrip.teams.away.abbreviation,
                logo : this.data.gameStrip.teams.away.logo,
                url : this.data.gameStrip.teams.away.url
            };

            head2headEvents.map(function(game, i){

                var scores = game.score.split('-');
                var winningTeamScore = scores[0];
                var loosingTeamScore = scores[1];
                var gameResult = '' + game.gameResult;
                var concatenatedScore = '';
                var atVs = game.atVs;
                var homeTeam = home;
                var awayTeam = away;

                if (atVs == "vs"){
                    if(gameResult == "W" || gameResult == "D"){
                        concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
                    }else{
                        concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
                    }
                }else{
                    homeTeam = away;
                    awayTeam = home;
                    if(gameResult == "W" || gameResult == "D"){
                        concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
                    }else{
                        concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
                    }
                }

                head2head.push({
                    result : gameResult,
                    home : homeTeam,
                    away : awayTeam,
                    date : game.gameDate,
                    league : game.leagueName,
                    score : concatenatedScore,
                    url : self.getGameUrl(game.links)
                });
            });
        }catch(e){}

        return head2head;
    },

    getGameUrl: function(links){
        for (var i = 0, len = links && links.length; i < len; i++) {
            var link = links[i];
            if (link.text === "Match") {
                return link.href;
            }
        }
        return '#';
    },

    getRecentForm: function(){

        var recentForm = {
            home : [],
            away : []
        };

        try{
            var self = this;
            var formData = this.data.form || [];

            formData.map(function(form, i) {
                var isHomeTeam = (form.team.id === self.data.gameStrip.teams.home.id);
                form.events.map(function(game, j){

                    var homeTeam = form.team;
                    var awayTeam = game.opponent;
                    var scores = game.score.split('-');
                    var winningTeamScore = scores[0];
                    var loosingTeamScore = scores[1];
                    var gameResult = '' + game.gameResult;
                    var concatenatedScore = '';
                    var atVs = game.atVs;

                    homeTeam.url = gameStripUtils.getTeamUrl(homeTeam);
                    homeTeam.logo =  homeTeam.logo || gameStripUtils.getDefaultLogo(homeTeam.logo);
                    awayTeam.url = gameStripUtils.getTeamUrl(awayTeam);
                    awayTeam.logo = awayTeam.logo || gameStripUtils.getDefaultLogo(awayTeam.logo);

                    if (atVs == "vs"){
                        if(gameResult == "W" || gameResult == "D"){
                            concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
                        }else{
                            concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
                        }
                    }else{
                        homeTeam = game.opponent;
                        awayTeam = form.team;
                        if(gameResult == "W" || gameResult == "D"){
                            concatenatedScore = loosingTeamScore + '-' + winningTeamScore;
                        }else{
                            concatenatedScore = winningTeamScore + '-' + loosingTeamScore;
                        }
                    }

                    recentForm[isHomeTeam ? 'home' : 'away'].push({
                        result : gameResult,
                        home : homeTeam,
                        away : awayTeam,
                        date : game.gameDate,
                        league : game.leagueName,
                        score : concatenatedScore,
                        url : self.getGameUrl(game.links)
                    });
                });
            });

        }catch(e){}

        return recentForm;
    },

    getPlayerStats: function(statsFilter, home){
        var filtered = [];
        try{
            var rosters = this.data.rosters;
            var playerList = home && rosters[0].homeAway === 'home' ? rosters[0].roster : rosters[1].roster;

            var orderedList = this.data.playersList;
            var orderedPlayerMap = orderedList[home ? 'home' : 'away'].playerMap;

            for (var i = 0; i < playerList.length; i++) {

                var player = playerList[i];
                var athlete = player.athlete || {};
                var playerPos = orderedPlayerMap[athlete.id];
                var playerDetail = {
                    name : athlete.displayName,
                    id : athlete.id,
                    jersey : player.jersey,
                    position : player.position.abbreviation,
                    positionName : player.position.name,
                    stats : [],
                    href : athlete.links && athlete.links[0] && athlete.links[0].href || '#'
                };
                var stats = player.stats;
                for (var j = 0; j < stats.length; j++) {
                    var stat = stats[j];
                    var sStatName = stat.name;
                    // backward compatability for migration of data.
                    if(sStatName === 'tryAssists'){
                        sStatName = 'tryAssist'
                    }
                    if(statsFilter[sStatName]){
                        playerDetail.stats[statsFilter[sStatName].index] = stat;
                    }
                }
                filtered[playerPos] = playerDetail;
            }
        }catch(e){}
        return filtered;
    }
});

module.exports = ScoreStore;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/stores/ScoreStore.js
 **/